/**
 * Jump to some DOM element
 */
export default {
  methods: {
    $jumpTo (selector) {
      const el = document.querySelectorAll('#start')[0]
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      } else {
        throw new Error('Element not supplied.')
      }
    },
    $routePush (route, switchTimeout = 250) {
      this.$store.commit('loading/SET_LOADING_APP', true)
      setTimeout(() => {
        scroll(0, 0)
        window.scrollTo(0, 0)
        window.scrollTop = 0
      }, 50)
      setTimeout(() => {
        this.$router.push(route)
      }, switchTimeout)
    },
    $routeBack () {
      this.$store.commit('loading/SET_LOADING_APP', true)
      setTimeout(() => this.$router.go(-1), 200)
    }
  }
}
